import { useWizard } from "react-use-wizard";
import React from "react";
import NavigateBack from "../../components/navigateBack";
import Email from "../../components/email";

function EmailStep({ qKey, onSubmitHandler, state }) {
  const { previousStep, nextStep } = useWizard();
  const _qKey = qKey;

  const onNextFn = (data) => {
    console.log(data);
    onSubmitHandler({ [_qKey]: data });
    nextStep();
  };

  return (
    <>
      <NavigateBack onClickHandler={previousStep} />
      <Email initState={state} onSubmitHandler={onNextFn} />
    </>
  );
}

export default EmailStep;
